import React, { useContext, useEffect, useState } from "react";
import { BACKEND_API } from "../../constants/backendApi";

//Style
import "./PopUpComponent.css";

//Component
import ButtonComponent from "../ButtonComponent/ButtonComponent";

//Context
import { PopupContext } from "../../context/PopupContext";
import { LoadingContext } from "../../context/LoadingContext";

const PopUpComponent = ({ content, btnData, userData }) => {
  const { setShowPopup, setPopupData } = useContext(PopupContext);

  const [formData, setFormData] = useState(content?.complementInfo?.data ?? {});

  const token = localStorage.getItem("token");

  const [insurerName, setInsurerName] = useState("");

  useEffect(() => {
    try {
      const selectInsurer = document.getElementById("insurer");

      if (selectInsurer) {
        const insuranceIdLS = localStorage.getItem("insurance_id");

        try {
          fetch(`${BACKEND_API}/api/insurance-companies`, {
            method: "GET",
            credentials: "include",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-type": "application/json",
            },
          })
            .then((res) => res.json())
            .then(({ data }) => {
              const selectedInsurer = data.filter(
                (item) => item.IdAseguradora === insuranceIdLS
              );

              selectedInsurer.map((insurer) => {
                setInsurerName(insurer.NombreAseguradora);

                const option = document.createElement("option");
                option.text = insurer.NombreAseguradora;
                option.value = insurer.IdAseguradora;
                selectInsurer.appendChild(option);

                const optionsArray = Array.from(selectInsurer.options);

                optionsArray.sort((a, b) => a.text.localeCompare(b.text));

                selectInsurer.innerHTML = "";

                return optionsArray.forEach((option) => {
                  selectInsurer.appendChild(option);
                });
              });
            });
        } catch (err) {
          console.log(err);
        }
      }
    } catch (err) {
      console.log(err);
    }
  }, []);

  const handleForm = (e) => {
    if (e.target.title === "text") {
      if (e.target.name === "placa") {
        e.target.value = e.target.value
          .replace(/\s/g, "")
          .toUpperCase()
          .substring(0, 6);
      } else {
        const inputValue = e.target.value.trimStart();
        const lowercaseValue = inputValue.toLowerCase();

        e.target.value = lowercaseValue
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");
      }

      if (e.target.value.trim() === "") {
        e.target.nextElementSibling.classList.remove("hide");
      } else {
        e.target.nextElementSibling.classList.add("hide");
      }
    }

    if (e.target.title === "select") {
      if (e.target.name === "no_cuotas") {
        if (
          formData.total_annual >= 1000001 &&
          e.target.value >= 1 &&
          e.target.value <= 1
        ) {
          e.target.nextElementSibling.innerText =
            "Si la prima total anual es mayor a 1'000.001, el número de cuotas debe ser entre 2 a 11 meses.";
          e.target.nextElementSibling.classList.remove("hide");
        } else if (
          formData.total_annual >= 500001 &&
          formData.total_annual <= 1000000 &&
          ((userData.document === "900697686" && e.target.value < 7) ||
            (userData.document !== "900697686" && e.target.value < 10))
        ) {
          e.target.nextElementSibling.innerText = `Si la prima total anual es entre 500.001 y 1'000.000, el número de cuotas no debe ser menor a ${
            userData.document === "900697686" ? "7" : "10"
          } meses.`;
          e.target.nextElementSibling.classList.remove("hide");
        } else {
          e.target.nextElementSibling.classList.add("hide");
        }
      } else {
        if (e.target.value.trim() === "") {
          e.target.nextElementSibling.classList.remove("hide");
        } else {
          e.target.nextElementSibling.classList.add("hide");
        }
      }
    }

    if (e.target.title === "number") {
      e.target.value = e.target.value.replace(/[^0-9]/g, "");

      if (e.target.name === "prima_total") {
        if (e.target.value <= 500000) {
          e.target.nextElementSibling.innerText =
            "La prima total anual debe ser mayor a 500.000.";
          setTimeout(() => {
            e.target.nextElementSibling.classList.remove("hide");
          }, 10);
        }
      }

      if (e.target.value.trim() === "") {
        e.target.nextElementSibling.classList.remove("hide");
      } else {
        e.target.nextElementSibling.classList.add("hide");
      }
    }

    if (e.target.name === "vig_inicial") {
      const currentDate = new Date(e.target.value);
      const limitDate = new Date();
      const limitDateMin = new Date();

      limitDateMin.setMonth(limitDateMin.getMonth() - 2);

      limitDate.setDate(limitDate.getDate() + 45);

      if (currentDate > limitDate || currentDate < limitDateMin) {
        e.target.nextElementSibling.innerText =
          "La vigencia inicial no debe ser mayor a 45 dias, ni anterior a 2 meses";
        e.target.nextElementSibling.classList.remove("hide");
      } else {
        e.target.nextElementSibling.classList.add("hide");
      }
    }

    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const totalAnnualFormatted = Number(formData.prima_total).toLocaleString(
      "en-CO"
    );

    setShowPopup(false);

    setPopupData({
      hasTitle: false,
      hasInfoArr: true,
      infoArr: [
        "Por favor, revisa cuidadosamente la información ingresada para la creación del crédito. Ten en cuenta que si los datos no son correctos, el crédito no podrá ser procesado, lo que podría generar reprocesos y retrasos. Asegúrate de confirmar los detalles antes de continuar.",
        `Nombre completo: ${formData.nombres} ${formData.apellidos}`,
        `No de documento: ${formData.numero_doc}`,
        `Prima total anual: ${totalAnnualFormatted}$`,
        `No de cuotas: ${formData.no_cuotas}`,
        `No de poliza: ${formData.no_poliza}`,
        `Vigencia inicial: ${formData.vig_inicial}`,
        `Placa: ${formData.placa}`,
        `Aseguradora: ${insurerName}`,
      ],
      isForm: false,
      type: "option",
      showOptionBtn: true,
      btnData: [
        {
          page: "login",
          type: "redirect",
          complementInfo: {
            ...content?.complementInfo,
            formData,
          },
          action: "submit-data",
          text: "Aceptar",
          title: "aceptar",
          redirect: "/admin/crear-credito/formulario-confirmar",
        },
        {
          page: "login cancel",
          type: "redirect",
          action: "close-popup",
          text: "Cancelar",
          title: "cancelar",
          redirect: "/admin/crear-credito/formulario-confirmar",
        },
      ],
    });

    setShowPopup(true);
  };

  return (
    <div className="popup-bg">
      <div className="popup-container">
        {content.hasTitle && <h1 className="popup-title">{content.title}</h1>}
        <img
          className="popup-icon"
          src={
            content.type === "error"
              ? "https://pagina-crediseguro.s3.amazonaws.com/portal-crediseguro/assets/sign-error.webp"
              : content.type === "correct"
              ? "https://pagina-crediseguro.s3.amazonaws.com/portal-crediseguro/assets/icons/check-icon.webp"
              : ""
          }
          alt=""
        />
        <p className="popup-msg">{content.info}</p>
        {content.hasInfoArr && (
          <div className="info-arr-container">
            {content.infoArr.map((infoTxt, i) => {
              return (
                <div className="info-arr-container">
                  <p className="popup-msg" key={i}>
                    {infoTxt}
                  </p>
                </div>
              );
            })}
          </div>
        )}
        {content?.isForm && (
          <form
            className="fws-form-container"
            onChange={handleForm}
            onSubmit={handleSubmit}
          >
            <div className="input-container">
              {content?.formField.map((input) => {
                if (input.isSelect) {
                  return (
                    <label key={input.key}>
                      {input.title}
                      <select
                        value={formData[input.name]}
                        name={input.name}
                        title={input.typeVal}
                        id={input.name}
                        required
                        disabled={input.isBlocked}
                        autoComplete="off"
                      >
                        {!input.isBlocked && input.hasNoneOption && (
                          <option value="">--Ninguno--</option>
                        )}
                        {input.options.map((option, i) => {
                          return (
                            <option
                              key={i}
                              value={option.value ? option.value : option.title}
                              selected={option.isSelected}
                            >
                              {option.title}
                            </option>
                          );
                        })}
                      </select>
                      <span className="mandatory-text hide">
                        Campo Obligatorio
                      </span>
                    </label>
                  );
                }

                return (
                  <label key={input.key}>
                    {input.title}
                    <input
                      title={input.typeVal}
                      type={input.type}
                      name={input.name}
                      id={input.name}
                      value={formData[input.name]}
                      autoComplete="off"
                      required
                      disabled={input.isBlocked}
                    />
                    <span className="mandatory-text hide">
                      Campo Obligatorio
                    </span>
                  </label>
                );
              })}
            </div>
            <div className="fws-btns-container">
              <button type="submit" className="fws-btn" title="Enviar">
                Enviar
              </button>
            </div>
          </form>
        )}
        {content.isFromWhatsapp && (
          <ButtonComponent
            btnData={{
              page: "login popup",
              type: "button",
              action: "from-whatsapp",
              text: "Cerrar",
              title: "Cerrar",
            }}
          />
        )}
        {content.type !== "option" && !content.isFromWhatsapp && (
          <ButtonComponent btnData={btnData} />
        )}
        {content.showOptionBtn &&
          content.type === "option" &&
          !content.isFromWhatsapp && (
            <div className="popup-option-container">
              {content.btnData.map((btn, i) => {
                return <ButtonComponent key={i} btnData={btn} />;
              })}
            </div>
          )}
      </div>
    </div>
  );
};

export default PopUpComponent;
